<template>
 <safety-questions
   v-model="questions"
   :appointment="appointment"
   :patient-id="patientId"
   :fetch-route="fetchRoute"
   :save-route="saveRoute"
   :show-warning="true"
   ref="safetyQuestions"
   @loadingStart="loading=true"
   @loadingEnd="loading=false"
   :key="key"
 />
</template>

<script>
import { mapGetters } from 'vuex'
import SafetyQuestions from '@components/appointment/SafetyQuestions.vue';

export default {
  name: 'AppointmentCarouselSafetyQuestions',
  components: { SafetyQuestions },
  props: {},
  data () {
    return {
      questions: [],
      loading: true,
      key: 0
    }
  },
  computed: {
    ...mapGetters('app', { currentPatient: 'currentUser' }),
    ...mapGetters('appointment', { appointment: 'appointment' }),
    patientId () {
      return this.currentPatient && this.currentPatient.id ? this.currentPatient.id : ''
    },
    saveRoute () {
      return `patients/${ this.patientId }/appointments/${ this.appointment.id }/safety-questions`
    },
    fetchRoute () {
      return `patients/${ this.patientId }/appointments/${ this.appointment.id }/safety-questions`
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // TODO this would need to be moved to the parent component
      this.$store.commit('app/setAppBarTitle', 'Safety Questions')
      this.$store.commit('app/setAppBarButton1', {
        label: 'Back',
        icon: 'mdi-chevron-left',
        click: () => {
          this.$emit('prev')
        }
      })
      this.$store.commit('app/setAppBarButton2', {
        label: 'Next',
        icon: 'mdi-chevron-right',
        click: () => {
          if (this.loading) {
            return
          }

          this.$refs.safetyQuestions.getDataFromRestApi((questions) => {
            const missingPatientQuestion = questions.findIndex(el => el.isMandatory && !el.answer)

            if (missingPatientQuestion > -1) {
              this.$_notify.error(this.$_t('Please answer all required safety questions marked with *'))
              this.$refs.safetyQuestions.setLoading(false)
              this.$refs.safetyQuestions.goTo(missingPatientQuestion)
              return
            }

            const missingQuestion = questions.findIndex(el => !el.isAllMandatoryQuestionsAnswered)
            if (missingQuestion > -1) {
              this.key++; // reload component
              this.$refs.safetyQuestions.setLoading(false)
              return
            }

            setTimeout(() => {
              this.$refs.safetyQuestions.setLoading(false)
            }, 1000)

            this.$emit('next')
          })
        }
      })
      this.$store.dispatch('app/appBarShow')
      this.$root.$emit('scrollToTop')
    },
  },
  watch: {}
}
</script>
